const TimeLabel = ({ ms = 0 }) => {
  const time = new Date(ms || 0); // still need this in case ms = NaN
  const isHourTimeLabel = time.getUTCHours() >= 1;
  return time.toISOString().slice((isHourTimeLabel ? 11 : 14), -5);
};

export default TimeLabel;
